import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { TrustBadges } from "@/components/TrustBadges";
import { HeroMockup } from "./HeroMockup";

export function HeroSection({ settings }) {
  return (
    <section className="relative overflow-hidden">
      <div className="hero-orbs" aria-hidden="true" />
      <div className="bg-dots-fade absolute inset-0 -z-10" />
      <div className="max-w-7xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-16 grid lg:grid-cols-12 gap-14 items-center">
        <div className="lg:col-span-6 fade-up">
          <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full mb-6"
               style={{ background: "rgba(0, 212, 170, 0.12)", border: "1px solid rgba(0, 212, 170, 0.30)" }}>
            <span className="w-1.5 h-1.5 rounded-full animate-pulse-soft" style={{ background: "#00D4AA" }} />
            <p className="font-mono text-[11px] tracking-wider uppercase" style={{ color: "#00D4AA" }}>
              For UK conveyancing &amp; leasehold firms
            </p>
          </div>

          <h1 className="h-display text-5xl md:text-6xl lg:text-[64px] text-white" data-testid="hero-headline">
            {settings.hero_headline}
          </h1>

          <p className="mt-6 text-lg text-slate-400 max-w-xl leading-relaxed" data-testid="hero-subheadline">
            {settings.hero_subheadline}
          </p>

          <div className="mt-9 flex flex-wrap gap-3">
            <Link to="/demo" data-testid="hero-cta-demo" className="btn-accent">
              Book a Demo <ArrowRight className="w-4 h-4" />
            </Link>
            <Link to="/how-it-works" data-testid="hero-cta-howitworks" className="btn-ghost">
              See how it works
            </Link>
          </div>

          <TrustBadges className="mt-6" />
        </div>

        <div className="lg:col-span-6 fade-up delay-200">
          <HeroMockup />
        </div>
      </div>
    </section>
  );
}
